import { defineComponent as _defineComponent } from 'vue'
import { FitHalfScreenDialog } from '@tencent/wphk-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'merchants-dialog',
  props: {
    visible: { type: Boolean },
    info: null
  },
  emits: ['close'],
  setup(__props: any, { emit: emits }) {




function handleClose() {
  emits('close');
}


return { __sfc: true,emits, handleClose, FitHalfScreenDialog }
}

})